import React, { FC, ReactNode } from 'react';
import { TButtonTypes } from 'components/Button/Button.types';
import { Icon, TIconNames } from 'components/Icon';
import Button from 'components/Button/Button';

type TTTimeTrackerStopProps = {
  onClick: () => void;
  /* An icomoon glyph, or `icon` for artwork that has to be drawn as an SVG —
     the design's stroked icons cannot go through `Icon`, which colours by fill. */
  iconName?: TIconNames;
  icon?: ReactNode;
  outline?: boolean;
  loading?: boolean;
  disabled?: boolean;
};
const TimeTrackerAction: FC<TTTimeTrackerStopProps> = ({
  onClick,
  outline,
  iconName,
  icon,
  loading = false,
  disabled,
}) => {
  return (
    <Button
      disabled={disabled}
      loading={loading}
      onClick={onClick}
      width={32}
      type="primary"
      color={TButtonTypes.Info}
      shape="circle"
      outline={outline}
      icon={icon || (iconName && <Icon icon={iconName} size={15} />)}
    />
  );
};

export default TimeTrackerAction;
